export default {
  "discover_your": "Discover Your",
  "ascendant": "Ascendant",
  "rising_sign_analysis": "Rising Sign Analysis",
  "ascendant_description": "It shapes your personality, appearance, and life path, while Moon and Sun signs guide periodic predictions.",
  "exact_time_critical_for_ascendant": "Exact birth time is critical for accurate ascendant calculation",
  "location_essential_for_ascendant": "Precise location is essential for determining your rising sign",
  "complete_ascendant_analysis": "Complete Ascendant Analysis",
  "rising_sign_identification": "Rising Sign Identification",
  "personality_traits_analysis": "Personality Traits Analysis", 
  "first_impression_insights": "First Impression Insights",
  "life_path_guidance": "Life Path Guidance",
  "focused_ascendant_analysis_note": "Specialized analysis focused on your rising sign and ascendant traits.",
  "pay_and_generate_analysis": "Pay & Generate Analysis",
  "your_rising_sign_detailed": "Your rising sign detailed breakdown",
  "personality_mask_analysis": "Personality mask and outer presentation analysis",
  "appearance_and_style_insights": "Appearance and style insights",
  "life_approach_patterns": "Life approach and behavioral patterns",
  "sample_ascendant_analysis": "Sample Ascendant Analysis",
  "sample_ascendant_description": "This is how your personalized ascendant report will look with detailed insights.",
  "rising_signs": "Rising Signs",
  "aries_rising": "Aries Rising",
  "taurus_rising": "Taurus Rising",
  "gemini_rising": "Gemini Rising",
  "cancer_rising": "Cancer Rising",
  "leo_rising": "Leo Rising",
  "virgo_rising": "Virgo Rising",
  "ascendant_analysis_processing": "Your ascendant analysis is being prepared by our expert astrologers.",
  "detailed_ascendant_report_pdf": "Detailed Ascendant Report (PDF Format)",
  "rising_sign_characteristics": "Rising Sign Characteristics & Traits",
  "personality_presentation_insights": "Personality Presentation Insights",
  "first_impression_analysis": "First Impression & Social Persona Analysis",
  "life_approach_guidance": "Life Approach & Behavioral Guidance",
  "your_ascendant_analysis_status": "Your Ascendant Analysis Status",
  "processing_your_analysis": "Processing Your Analysis",
  "analysis_processing_message": "Our expert astrologers are working on your personalized ascendant analysis."
}
